export default (history) => {
  history.listen((location) => {
    if (window.ga) {
      window.ga('gtm1.set', 'page', location.pathname + location.search);
      window.ga('gtm1.send', 'pageview');
    }
  });
};
